import React from 'react';
import { Container } from 'react-bootstrap';
import { Route, Switch } from 'react-router-dom';
import Suspense from '../../shared/components/suspense';
import ErrorBoundaryWrapper from '../../shared/components/error-boundary-wrapper';
import retryLazy from '../retry-lazy';
import { Routes } from '../../shared/routes';

const BillingSubscription = React.lazy(() =>
  retryLazy(
    () =>
      import(
        /* webpackChunkName: "billing-subscription" */ '../settings/components/billing-subscription'
      ),
  ),
);

const Billing: React.FC = () => (
  <Container fluid className="prospect-container p-0">
    <ErrorBoundaryWrapper>
      <Suspense>
        <Switch>
          <Route path="/billing" component={BillingSubscription} />
          <Route
            path={Routes.Setting_Billing_Upgrade_Plan}
            component={BillingSubscription}
          />
        </Switch>
      </Suspense>
    </ErrorBoundaryWrapper>
  </Container>
);

export default Billing;
